export const environment = {
  production: false,
  baseHref: '/',
  apiScopeUrl: 'api://ba543c5f-f647-4e9d-92f2-c683779b1496/access_as_user',
  clientId: '7abeef91-0b53-4a62-aa4e-05b7b4611a6f',
  webApi: 'https://api.store-compliance.dev.amgreetings.com/api',
  authEnabled: true,
  userRolesAuthorization: false,
  tablePaginationSizes: [10, 25, 100],
  pageableAllItems: 99999,
  noLoadingSpinnerHeader: 'loading-spinner-disabled',
  httpRequestChunkSize: 100,
  googleMapsApi: 'AIzaSyDQvR0FIt2qTkts_a9OrpEDHvdKhKdcepE',
};
